/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId, botConfig) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
      bot_config: botConfig,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  getMessageTemplates(inboxId, params = {}, config = {}) {
    return axios.get(`${this.url}/${inboxId}/message_templates`, {
      ...config,
      params,
    });
  }

  updateWhatsappBusinessManagementToken(inboxId, businessManagementToken) {
    return axios.put(
      `${this.url}/${inboxId}/whatsapp_business_management_token`,
      {
        business_management_token: businessManagementToken,
      }
    );
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  rotateHmacToken(inboxId) {
    return axios.post(`${this.url}/${inboxId}/rotate_hmac_token`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }

  setCallingConfig(inboxId, callingConfig) {
    return axios.post(`${this.url}/${inboxId}/set_calling_config`, {
      calling_config: callingConfig,
    });
  }

  getMetaCallingSettings(inboxId) {
    return axios.get(`${this.url}/${inboxId}/meta_calling_settings`);
  }

  // Counts of what a merge into destinationId would move, plus the contact source ids that exist
  // on both sides and block it. Read only.
  // Zadarma: available PBX extensions plus the agent each one is assigned to.
  getZadarmaExtensions(inboxId) {
    return axios.get(`${this.url}/${inboxId}/zadarma_extensions`);
  }

  createZadarmaExtension(inboxId) {
    return axios.post(`${this.url}/${inboxId}/create_zadarma_extension`);
  }

  setZadarmaExtension(inboxId, agentId, extension) {
    return axios.post(`${this.url}/${inboxId}/set_zadarma_extension`, {
      agent_id: agentId,
      extension,
    });
  }

  deleteZadarmaExtension(inboxId, agentId) {
    return axios.delete(`${this.url}/${inboxId}/zadarma_extension`, {
      data: { agent_id: agentId },
    });
  }

  getMergePreview(sourceId, destinationId) {
    return axios.get(`${this.url}/${sourceId}/merge`, {
      params: { destination_id: destinationId },
    });
  }

  // Moves everything from sourceId into destinationId and deletes the source, in the background.
  mergeInbox(sourceId, destinationId) {
    return axios.post(`${this.url}/${sourceId}/merge`, {
      destination_id: destinationId,
    });
  }

  // WAHA inboxes: WhatsApp message for callers rejected because the line is busy
  setCallBusyMessage(inboxId, message) {
    return axios.post(`${this.url}/${inboxId}/set_call_busy_message`, {
      call_busy_message: message,
    });
  }

  setCallRecording(inboxId, { recordingEnabled, transcriptionEnabled }) {
    return axios.post(`${this.url}/${inboxId}/set_call_recording`, {
      recording_enabled: recordingEnabled,
      transcription_enabled: transcriptionEnabled,
    });
  }
}

export default new Inboxes();
